// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBw8Iloyy7G7Ty0Wjm8zblg6sbcpAAWdM4",
  authDomain: "air-impact-map.firebaseapp.com",
  projectId: "air-impact-map",
  storageBucket: "air-impact-map.appspot.com",
  messagingSenderId: "189105589910",
  appId: "1:189105589910:web:34922acfe25ae6d0bd7cb7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export { app };